import React from 'react';
import PropTypes from 'prop-types';
import ManageSubscriptions from './manage-subscriptions';
import ManageFollowers from './manage-followers';
import { Tooltip } from '@vitalsource/vstui';

class ManageSharing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSmallScreen: Fraction.Helpers.isSmallScreen(),
      followingTab: !Fraction.Brand.Sharing.showFollowings && Fraction.Brand.Sharing.showFollowers,
      showTooltip: false
    };

    this._resetManage = this._resetManage.bind(this);
    this._followingTab = this._followingTab.bind(this);
    this._followersTab = this._followersTab.bind(this);
    this._manageHighlighters = this._manageHighlighters.bind(this);
    this.showTooltip = () => this.setState({ showTooltip: true });
    this.hideTooltip = () => this.setState({ showTooltip: false });
  }

  componentDidMount() {
    this.props.toggleCloseButton(true);
    $(window).on('resize', this._resetManage);
  }

  componentWillUnmount() {
    $(window).unbind('resize', this._resetManage);
  }

  _resetManage() {
    if (this.state.currentSmallScreen!==Fraction.Helpers.isSmallScreen()){
      this.setState({currentSmallScreen: Fraction.Helpers.isSmallScreen()});
    }
    this.props.toggleCloseButton(true);
  }

  _followersTab() {
    this.setState({followingTab: true}); 
  }

  _followingTab() {
    this.setState({followingTab: false});
  }

  _manageHighlighters(e) {
    Fraction.Helpers.removeVSTModal(() => {
      this.props.manageHighlighters(e, this.props.isbn);
    }, {fade: 0});
  }

  renderTab() {
    if (this.state.followingTab) {
      return (
        <ManageFollowers isbn={this.props.isbn} manageHighlighters={this._manageHighlighters} />
      );
    }
    return (
      <ManageSubscriptions isbn={this.props.isbn} />
    );
  }

  renderFollowingTabButton() {
    if (Fraction.Brand.Sharing.showFollowings) {
      return (
        <button aria-selected={!this.state.followingTab}
                id="imFollowing"
                className={"noButton sharing-tab"+(this.state.followingTab ? "" : " active")}
                onClick={this._followingTab}
                role="tab">
          <span>{i18n.t("sharing.following")}</span>
        </button>
      );
    }
  }

  renderTabButton() {
    if (Fraction.Brand.Sharing.showFollowers) {
      return (
        <button aria-selected={this.state.followingTab}
                id="myFollowers"
                className={"noButton sharing-tab"+(this.state.followingTab ? " active" : "")}
                onClick={this._followersTab}
                role="tab">
          <span>{i18n.t("sharing.followers")}</span>
        </button>
      );
    }
  }

  render() {
    return (
      <span>
        <div className="sharing-tab-container" role="tablist">
          {this.renderFollowingTabButton()}
          {this.renderTabButton()}
        </div>
        {this.renderTab()}
        {!this.state.followingTab &&
        <div className="sharing-footer">
          <div>{i18n.t("sharing.no-shared-highlighters")}</div>
          <button
            aria-describedby="sharing-tooltip"
            className="sharing-tips noButton"
            onBlur={this.hideTooltip}
            onFocus={this.showTooltip}
            onMouseEnter={this.showTooltip}
            onMouseLeave={this.hideTooltip}
            >
            {i18n.t("sharing.sharing-tips")}
          </button>
          <span
            aria-hidden={!this.state.showTooltip}
            className={this.state.showTooltip ? 'visible' : 'offScreen'}
            id="sharing-tooltip"
            role="tooltip"
            >
            <ul className='sharing-tips-list'>
              <li>{i18n.t("sharing.sharing-tips-items.first")}</li>
              <li>{i18n.t("sharing.sharing-tips-items.second")}</li>
              <li>{i18n.t("sharing.sharing-tips-items.third")}</li>
            </ul>
          </span>
        </div>
        }
      </span>
    );
  }
}

ManageSharing.propTypes = {
  isbn: PropTypes.string,
  manageHighlighters: PropTypes.func,
};

ManageSharing.defaultProps = {
};

module.exports = ManageSharing;
